module.exports = __webpack_public_path__ + "img/Group 892one2.5e150ee9.svg";